"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* istanbul ignore next */
var hasher = function hasher(value) {
  return window.crypto.subtle.digest('SHA-256', value);
};

var _default = hasher;
exports.default = _default;